import { Star, ExternalLink } from 'lucide-react';
import { useSite } from '../lib/SiteContentContext';

/**
 * Compact Trustpilot summary shown near the hero.
 * Reads live data from the CMS.
 */
export default function TrustpilotBadge() {
  const { trustpilot } = useSite();
  const summary = trustpilot?.summary || {};
  const url = summary.profileUrl || 'https://uk.trustpilot.com/review/sciencesorted.co.uk';
  const rating = summary.rating ? `${summary.rating} / 5` : '4.9 / 5';

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="trustpilot-badge"
      className="group inline-flex items-center gap-3 rounded-full bg-white border border-black/10 pl-2 pr-4 py-1.5 shadow-sm hover:shadow-md transition-shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-ink"
      aria-label="Read Science Sorted reviews on Trustpilot (opens in a new tab)"
    >
      <div className="flex items-center gap-1">
        {[...Array(5)].map((_, i) => (
          <span key={i} className="w-5 h-5 grid place-items-center bg-[#00B67A]" aria-hidden="true">
            <Star className="w-3 h-3 text-white fill-white" strokeWidth={0} />
          </span>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <span className="font-semibold text-sm text-brand-ink">Excellent</span>
        <span className="text-xs text-black/60">on Trustpilot</span>
        <ExternalLink className="w-3.5 h-3.5 text-black/40 group-hover:text-black/70" aria-hidden="true" />
      </div>
    </a>
  );
}
